import React, { useContext } from 'react';
import BonusPeriodsContext from '../contexts/BonusPeriodsContext';
import FlexCentered from './Common/FlexCentered';
import Typography from 'kingpin/atoms/Typography';

const BonusPeriodGadgetGuard = ({
  isBonusPeriodMode,
  children,
}: {
  isBonusPeriodMode: boolean;
  children: React.ReactNode;
}) => {
  const { bonusPeriods } = useContext(BonusPeriodsContext);

  if (isBonusPeriodMode && bonusPeriods.length === 0) {
    return (
      <FlexCentered>
        <Typography.Body type="Label">
          No bonus period available
        </Typography.Body>
      </FlexCentered>
    );
  }

  return <>{children}</>;
};

export default BonusPeriodGadgetGuard;
